export async function writeToClipboard(text: string): Promise<boolean> {
  if (environment.isTauri) {
    try {
      const { writeText } = await import('@tauri-apps/plugin-clipboard-manager');
      await writeText(text);
      return true;
    } catch (error) {
      console.error('Failed to write to Tauri clipboard:', error);
      return false;
    }
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'NotAllowedError') {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.left = '-999999px';
        textarea.style.top = '-999999px';
        document.body.append(textarea);
        textarea.focus();
        textarea.select();
        const success = document.execCommand('copy');
        textarea.remove();
        return success;
      } catch (fallbackError) {
        console.error('Failed to write to clipboard (fallback):', fallbackError);
        return false;
      }
    }
    console.error('Failed to write to clipboard:', error);
    return false;
  }
}
